// @core/api/endpoints/task/get_assignee_availability.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetAssigneeAvailabilityRequest,
  GetAssigneeAvailabilityResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Get assignee availability
 * Returns the free/busy schedule of one or more actors within a time range. Used for workforce planning — see when team members are available before assigning or scheduling tasks. Respects working hours, existing calendar events, and other scheduled tasks.
 */
export async function GetAssigneeAvailability(
  data: GetAssigneeAvailabilityRequest,
  options?: RequestOptions
): Promise<GetAssigneeAvailabilityResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/tasks/availability`;
  const requestOptions = options;
  return client.post<GetAssigneeAvailabilityResponse>(requestPath, data, requestOptions);
}
